var styles = {
    container: {
        display: 'flex',
        pl: '152px',
        backgroundColor: 'common.white',
        minHeight: '100vh',
        width: '100vw',
        '@media print': {
            pl: 0,
        },
    },
    fixedContainer: {
        pl: '328px',
    },
    mobile: {
        px: 1.6,
    },
    content: {
        mx: 'auto',
        p: 3.2,
        boxSizing: 'content-box',
        maxWidth: {
            xs: 1224,
            xl: 1400,
        },
        width: '100%',
        borderTopLeftRadius: 12,
        border: '1px solid',
        borderColor: '#DCDCDD',
        height: '100%',
        '@media print': {
            pl: 0,
        },
    },
    fullWidth: {
        maxWidth: '100% !important',
        p: 0,
    },
    nativeApp: {
        pt: 3.2,
    },
};
export default styles;
